import React, { useState } from 'react'
import { GoogleMap, LoadScript, OverlayView } from '@react-google-maps/api';

import IconMapMarker from "../components/icons/IconMapMarker"

const GoogleMaps = (data) => {

    const apiKey = typeof window !== 'undefined' ? window.GMAPS_KEY : ''

    const center = { lat: data.lat, lng: data.lng }
    const [mapContainerStyle] = useState({ width: '100%', height: '100%' })

    const options = {
        draggable: false,
        preventGoogleFontsLoading: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: [
            {
                featureType: "poi.business",
                stylers: [ { visibility: "off" } ]
            }
        ],
    }

    return (
        <LoadScript googleMapsApiKey={apiKey}>
            <GoogleMap
                id="single-location-map"
                mapContainerStyle={mapContainerStyle}
                zoom={data.zoom}
                center={center}
                options={options}
            >
                {data.marker ?
                <OverlayView position={center} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                        <div className="-ml-4 -mt-4">
                            <IconMapMarker w="40" h="40" />
                        </div>

                </OverlayView>
                : ''}
            </GoogleMap>
        </LoadScript>
    )
}

export default GoogleMaps;
